export default [
  {
    path: '/task-manager',
    component: () => import('@/views/taskManager/TaskManager.vue'),
    name: 'task-manager',
    meta: {
      title: 'Giao nhận việc',
      auth: true,
      permission: 'task-manage-access',
    },
  },
  {
    path: 'class/schedule/:id',
    name: 'class-slot',
    component: () => import('@/views/class/ClassSlots'),
    meta: {
      title: 'Điểm danh',
      auth: true,
    },
  },
  {
    path: '/class-attendance',
    component: () => import('@/views/ClassAttendance/index.vue'),
    name: 'class-attendance',
    meta: {
      title: 'Điểm danh',
      auth: true,
    },
  },
  {
    path: 'evaluate',
    name: 'Đánh giá',
    component: () => import('@/views/evaluate/index.vue'),
    meta: {
      title: 'Đánh giá',
    },
  },
]
